import BsyIconBtn from "../../BsyIconBtn";
import BsyRadioGroup from "../../BsyRadioGroup";
import BsyDialog from "../../BsyDialog";
import React from "react";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { BsyUtils } from "../../../utils/Utils";
import { SingPage } from "../../BsyForm/SingPage";

export function generateQuickBtn(item, event) {
  const btns = Object.entries({
    ...item,
    // forwardQuick: true,
    // backQuick: true,
    // closeQuick: true,
    // signQuick: true,
    // transferQuick: true,
  })
    .map(([key, val]) => {
      return typeof key === "string" &&
        key.indexOf("Quick") > -1 &&
        val === true
        ? key
        : null;
    })
    .filter((it) => it);
  const { custom_text = {}, data = [] } = item;
  let btnSort = [
    "forwardQuick",
    "backQuick",
    "signQuick",
    "transferQuick",
    "closeQuick",
  ];

  return (
    <div className={`quick-btn ${data.length > 0 ? "bottom" : ""}`}>
      {btnSort
        .filter((it) => btns.includes(it))
        .map((it) => {
          let type = it.split("Quick")[0];
          return (
            <div
              className="btn-item"
              onClick={(e) => {
                e.stopPropagation();
                event && event(type);
              }}
            >
              {custom_text[(type === "forward" ? "submit" : type) + "_text"] ||
                React.language("flow.action." + type)}
            </div>
          );
        })}
    </div>
  );
}

export function _switchBackNode(data, callback, cancel) {
  React.axios("/data/allow_back_nodes", data).then((res) => {
    const { data } = res;
    if (data.data.length === 0) {
      callback();
    } else {
      let items = [];
      data.data.map((e) => {
        items.push({
          text: e.name,
          value: e.flowId,
        });
        return null;
      });
      let id = "";
      BsyDialog({
        title: React.language("flow.action.back"),
        subTitle: "",
        height: 400,
        width: 400,
        noFooter: true,
        onClose: () => {
          cancel?.()
        },
        onContentCreate: (e) => {
          return (
            <>
              <div className={"bsy-back-node-list "}>
                <div className="title">
                  {React.language("flow.node.select")}
                </div>
                <BsyRadioGroup
                  layout={"vertical"}
                  items={items}
                  onStopEdit={(e) => {
                    id = e;
                  }}
                ></BsyRadioGroup>
                <div className="footer">
                  <BsyIconBtn
                    text={React.language("ok")}
                    click={() => {
                      if (id === "") {
                        tipAlert({
                          type: "warning",
                          msg: React.language("flow.back.node.select"),
                        });
                        return;
                      }
                      callback([id]);
                      e.closeAlter();
                    }}
                    type={"blue"}
                    mode={window.mode}
                  ></BsyIconBtn>
                  <BsyIconBtn
                    text={React.language("cancel")}
                    click={() => {
                      e.closeAlter();
                    }}
                    mode={window.mode}
                  ></BsyIconBtn>
                </div>
              </div>
            </>
          );
        },
      });
    }
  });
}

// 提交的时候读取一次表单数据，
export function _switchSubmit(data, callback) {
  React.axios("/data/read", data).then((res) => {
    BsyUtils.showAjaxTip(
      res.data,
      () => {
        const getWidgetType = (name, subwidgetName) => {
          if (subwidgetName) {
            return res.data.form.items
              .find((it) => it.widget.widgetName === name)
              ?.widget?.items?.find(
                (sit) => sit.widget.widgetName === subwidgetName
              )?.widget?.type;
          }

          return res.data.form.items.find((it) => it.widget.widgetName === name)
            ?.widget?.type;
        };

        callback({
          values: Object.entries(res.data.data).reduce((acc, cur) => {
            if (cur[0].indexOf("_widget_") > -1) {
              let data = cur[1];
              switch (getWidgetType(cur[0])) {
                case "user":
                case "dept":
                  if (cur[1]) data = cur[1].id || cur[1]._id;
                  break;
                case "usergroup":
                case "deptgroup":
                  if (!BsyUtils.isObjectEmpty(cur[1])) {
                    data = cur[1]
                      .map((it) => it.id || it._id)
                      .filter((it) => it);
                  }
                  break;
                case "datetime": {
                  data = cur[1] ? BsyUtils.parseDate(cur[1]).getTime() : "";
                  break;
                }
                case "subform": {
                  data = cur[1].map((it) => {
                    return Object.entries(it).reduce((acc1, cur1) => {
                      let data1 = cur1[1];
                      let subtype = getWidgetType(cur[0], cur1[0]);
                      switch (subtype) {
                        case "datetime": {
                          data1 = data1
                            ? BsyUtils.parseDate(data1).getTime()
                            : "";
                          break;
                        }
                        case "user":
                        case "dept":
                          if (cur1[1]) data1 = cur1[1].id || cur1[1]._id;
                          break;
                        case "usergroup":
                        case "deptgroup":
                          if (!BsyUtils.isObjectEmpty(cur1[1])) {
                            data1 = cur1[1]
                              .map((it) => it.id || it._id)
                              .filter((it) => it);
                          }
                          break;
                        default:
                      }
                      acc1[cur1[0]] = {
                        data: data1,
                        widgetType: subtype || "text",
                      };
                      return acc1;
                    }, {});
                  });
                  break;
                }
                default:
              }
              acc[cur[0]] = {
                data: data,
                visible: true,
              };
            }
            return acc;
          }, {}),
        });
      },
      () => { }
    );
  });
}

export function _submitSign(data, allowSignTypes, callback, cancel) {
  BsyDialog({
    title: React.language("flow.sign.pane"),
    height: 380,
    width: 540,
    noFooter: true,
    onClose: () => {
      cancel?.()
    },
    onContentCreate: (ref) => {
      return (
        <SingPage
          {...data}
          allowSignTypes={allowSignTypes}
          // is_dock_form={this.options.is_dock_form}
          onStopEdit={(signValue) => {
            callback(signValue);
            ref.closeAlter();
          }}
          onClose={() => {
            ref.closeAlter();

          }}
        ></SingPage>
      );
    },
  });
}

export function _switchTransferChargers(data, callback, cancel) {
  let o = new window.FX.ConfirmDialog({
    title: React.language("subform.data.load.tip9"),
    height: 589,
    width: 600,
    onClose: function () {
      cancel?.()
    },
    onOk: function () {
      let e = o.getWidgetByName("select_transfer_user");
      const candidateId = e.getValue();
      if (candidateId) {
        callback(candidateId);
        o.close();
      } else {
        tipAlert({
          type: "warning",
          msg: React.language("empty.report.tip25"),
        });
      }
    },
    contentWidget: {
      rowSize: [450],
      colSize: [570],
      padding: 15,
      items: [
        [
          {
            widgetName: "select_transfer_user",
            type: "transferdeptuser",
            // limit: candidates ? candidates : {},
            // entryId: d.entryId,
            // formId: d.formId || d.entryId,
            // dataId: d.dataId,
            // appId: d.appId,
            ...data,
          },
        ],
      ],
    },
  });
  o.show();
}
